module.exports = __webpack_public_path__ + "static/web_cover all devices.4fdeec04.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/web_cover all devices.png
// module id = 717
// module chunks = 154382131621592